export const OWNER_ROOM_PERMISSION_DENIED_MESSAGE = 'ルーム作成を行うにはメールアドレスとパスワードの登録が必要です。マイページから登録してください。';
export const OWNER_ROOM_CREATE_LIMIT_DENIED_MESSAGE = 'ルーム作成可能数が不足しています。';
export const OWNER_ROOM_CREATE_DENIED_MESSAGE = OWNER_ROOM_CREATE_LIMIT_DENIED_MESSAGE;

export const canCreateOwnerRoom = (user) => (
  Number(user?.owner_permission) > 0 &&
  Number(user?.owner_create_limit) > 0
);

export const getOwnerRoomCreateDeniedMessage = (user) => {
  if (Number(user?.owner_permission) <= 0) {
    return OWNER_ROOM_PERMISSION_DENIED_MESSAGE;
  }

  if (Number(user?.owner_create_limit) <= 0) {
    return OWNER_ROOM_CREATE_LIMIT_DENIED_MESSAGE;
  }

  return OWNER_ROOM_CREATE_DENIED_MESSAGE;
};
